import { render, staticRenderFns } from "./PrintSubTemplate.vue?vue&type=template&id=c65bfbf6&scoped=true"
import script from "./PrintSubTemplate.vue?vue&type=script&lang=js"
export * from "./PrintSubTemplate.vue?vue&type=script&lang=js"
import style0 from "./PrintSubTemplate.vue?vue&type=style&index=0&id=c65bfbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65bfbf6",
  null
  
)

export default component.exports